const de = {
    paymentPeriod: { monthly: 'pro Monat', yearly: 'pro Jahr' },
    paymentScope: { absolute: 'abs.', per_area: '/m²', per_unit: '/Einheit' },
    leaseTypes: { fixed: 'Frei', indexed: 'Index', graduated: 'Staffel', unknown: 'Unbekannt' },
    months: 'Monate',
    title: 'Mieterliste importieren',
    chooseMethod: 'Andere Methode wählen',
    file: 'Datei',
    analysis: 'Analyse',
    review: 'Prüfen',
    uploadTitle: 'Mieterliste aus Excel oder PDF auslesen',
    uploadDescription: 'Excel (.xlsx, .xlsm, .xls) oder PDF, bis 20 MB',
    upload: 'Mieterliste hochladen',
    fileSizeError: 'Bitte eine Datei mit höchstens 20 MB auswählen.',
    start: 'Import starten',
    blocked: 'Import nicht möglich',
    invalid: 'Die Mieterliste konnte nicht vollständig zugeordnet werden. Bitte die Quelldatei prüfen.',
    cancel: 'Import abbrechen',
    importing: 'Wird importiert …',
    importRows: (count: number) => `${count} Mieter importieren`,
    imported: (count: number) => `${count} Mieter wurden importiert.`,
    close: 'Zur Mieterliste',
    download: 'Excel herunterladen',
    downloading: 'Excel wird erstellt …',
    done: 'Schließen',
    downloadFailed: 'Excel konnte nicht erstellt werden. Bitte erneut versuchen.',
    overwrite: 'Die vorhandene Mieterliste wird durch den Import ersetzt. Dieser Vorgang kann nicht rückgängig gemacht werden.',
    exportLimitations: (count: number) =>
        `Betroffene Einheiten: ${count}. ` +
        'Zusätzliche Mietstaffeln, Zeiträume oder Leerstand ohne vollständige Datumsangaben werden nur in der Bemerkung gespeichert. Diese Angaben werden beim Vorlagenimport nicht als strukturierte Daten übernommen.',
    question: (index: number, count: number) => `Frage ${index} von ${count}`,
    tenants: 'Mieter',
    recommended: 'Empfehlung',
    customAnswer: 'Eigene Angabe',
    answerPlaceholder: 'Eigene Antwort eingeben',
    back: 'Zurück',
    accept: 'Akzeptieren',
    next: 'Weiter',
    analysisFailed: 'Datei konnte nicht ausgelesen werden.',
    saveFailed: 'Speichern fehlgeschlagen.',
    checkBeforeRetry: 'Bitte die Mieterliste neu laden und das Ergebnis prüfen, bevor Sie erneut importieren.',
    categories: 'Kategorien',
    details: 'Mieterdetails',
    summary: 'Zusammenfassung',
    preparing: 'Mieterliste vorbereiten',
    reading: 'Tabellen auslesen',
    extracting: 'Mieter erfassen',
    preparingImport: 'Import vorbereiten',
    applying: 'Angaben anwenden',
    updating: 'Zuordnung aktualisieren',
    checking: 'Mieter prüfen',
    progressTitle: 'Mieterliste wird ausgelesen',
    followUpTitle: 'Zuordnung wird aktualisiert',
    progressDescription: 'Die Mieterliste wird in mehreren Schritten ausgelesen. Das kann einige Minuten dauern.',
    followUpDescription: 'Ihre Angaben werden angewendet und die Mieterliste erneut geprüft.',
    retrying: 'Erneuter Versuch',
    failedSection: 'Abschnitt konnte nicht aktualisiert werden',
    preparingPreview: 'Vorschau wird vorbereitet',
    contractRent: 'Vertragsmiete',
    yearlyRent: 'Vertragsmiete pro Jahr',
    marketRent: 'Marktübliche Miete',
    leaseType: 'Vertragsart',
    privatePerson: 'Privatperson',
    yes: 'Ja',
    no: 'Nein',
    graduations: 'Staffeln',
    rentFree: 'Mietfreie Zeiten',
    vacancies: 'Leerstandszeiten',
}
const en: typeof de = {
    paymentPeriod: { monthly: 'per month', yearly: 'per year' },
    paymentScope: { absolute: 'total', per_area: '/m²', per_unit: '/unit' },
    leaseTypes: { fixed: 'Fixed', indexed: 'Indexed', graduated: 'Graduated', unknown: 'Unknown' },
    months: 'months',
    title: 'Import tenant list',
    chooseMethod: 'Choose another method',
    file: 'File',
    analysis: 'Analysis',
    review: 'Review',
    uploadTitle: 'Read a tenant list from Excel or PDF',
    uploadDescription: 'Excel (.xlsx, .xlsm, .xls) or PDF, up to 20 MB',
    upload: 'Upload tenant list',
    fileSizeError: 'Please select a file no larger than 20 MB.',
    start: 'Start import',
    blocked: 'Import unavailable',
    invalid: 'The tenant list could not be fully mapped. Please check the source file.',
    cancel: 'Cancel import',
    importing: 'Importing …',
    importRows: (count) => `Import ${count} tenants`,
    imported: (count) => `${count} tenants imported.`,
    close: 'Back to tenant list',
    download: 'Download Excel',
    downloading: 'Creating Excel …',
    done: 'Close',
    downloadFailed: 'Excel could not be created. Please try again.',
    overwrite: 'Importing replaces the existing tenant list. This action cannot be undone.',
    exportLimitations: (count) =>
        `Affected units: ${count}. ` +
        'Additional rent graduations, periods or vacancies without complete dates are saved only in the remarks. These details will not be imported as structured data when using the template.',
    question: (index, count) => `Question ${index} of ${count}`,
    tenants: 'Tenants',
    recommended: 'Recommended',
    customAnswer: 'Your answer',
    answerPlaceholder: 'Enter your answer',
    back: 'Back',
    accept: 'Accept',
    next: 'Continue',
    analysisFailed: 'The file could not be read.',
    saveFailed: 'Saving failed.',
    checkBeforeRetry: 'Please reload the tenant list and check the result before importing again.',
    categories: 'Categories',
    details: 'Tenant details',
    summary: 'Summary',
    preparing: 'Preparing tenant list',
    reading: 'Reading tables',
    extracting: 'Extracting tenants',
    preparingImport: 'Preparing import',
    applying: 'Applying answers',
    updating: 'Updating mapping',
    checking: 'Checking tenants',
    progressTitle: 'Reading tenant list',
    followUpTitle: 'Updating mapping',
    progressDescription: 'The tenant list is read in several steps. This may take a few minutes.',
    followUpDescription: 'Your answers are being applied and the tenant list is checked again.',
    retrying: 'Retrying',
    failedSection: 'Section could not be updated',
    preparingPreview: 'Preparing preview',
    contractRent: 'Contract rent',
    yearlyRent: 'Annual contract rent',
    marketRent: 'Market rent',
    leaseType: 'Lease type',
    privatePerson: 'Private individual',
    yes: 'Yes',
    no: 'No',
    graduations: 'Rent graduations',
    rentFree: 'Rent-free periods',
    vacancies: 'Vacancy periods',
}
export type TenantImportLanguage = 'de' | 'en'
export const tenantImportCopy = (language: TenantImportLanguage = 'de') => (language === 'en' ? en : de)
